import { CardActions as CardActionsMui } from "@mui/material";

const CardActions = ({ children, classes, disableSpacing, sx, className }) => {
  return (
    <CardActionsMui
      classes={classes}
      disableSpacing={disableSpacing}
      sx={{
        display: "flex",
        padding: "16px !important",
        alignItems: "center !important",
        margin: "auto 11px 4px auto !important",
        ...sx,
      }}
      className={className}
    >
      {children}
    </CardActionsMui>
  );
};

export default CardActions;
